export const GET_MOVEMENT_REASONS = 'providers/settings/PayIn/GET_MOVEMENT_REASONS';
export const GET_MOVEMENT_REASONS_DETAIL = 'providers/settings/PayIn/GET_MOVEMENT_REASONS_DETAIL';
export const CREATE_MOVEMENT_REASONS = 'providers/settings/PayIn/CREATE_MOVEMENT_REASONS';
export const DELETE_MOVEMENT_REASONS = 'providers/settings/PayIn/DELETE_MOVEMENT_REASONS';
export const EDIT_MOVEMENT_REASONS = 'providers/settings/PayIn/EDIT_MOVEMENT_REASONS';
